export default {
  featuresSection: {
    title: {
      fr: "",
      en: "",
    },
    subtitle: {
      fr: "",
      en: "",
    },
    features: {
      energy: {
        description: {
          fr: "Suivi des <strong>consommations</strong> et des <strong>productions énergétiques</strong> par zone fonctionelle.",
          en: "Track <strong>energy consumption</strong> and <strong>on-site production</strong> by functional area.",
        },
      },
      control: {
        description: {
          fr: "<strong>Pilotage et régulation</strong> des équipements techniques.",
          en: "Centralize <strong>control and optimize the regulation</strong> of technical equipment.",
        },
      },
      optimisation: {
        description: {
          fr: "Optimiser pour atteindre jusqu’à <strong>35% d’économie d’énergie</strong>.",
          en: "Unlock up to <strong>35% energy savings</strong> through smart optimization.",
        },
      },
      override: {
        description: {
          fr: "<strong>Dérogations manuelles</strong> pour accompagner la conduite du changement et garantir le <strong>confort des occupants.</strong>",
          en: "Enable <strong>manual overrides<strong> to support change management and keep <strong>occupants comfortable.</strong>",
        },
      },
      realTimeinfo: {
        description: {
          fr: "Bénéficier d’informations en <strong>temps réel</strong> pour assurer une <strong>maintenance prédictive et ciblée.</strong>",
          en: "Get <strong>real-time</strong> insights for <strong>predictive and targeted maintenance.</strong>",
        },
      },
      remoteDiagnostic: {
        description: {
          fr: "Diagnostiquer à distance et <strong>diminuer les interventions.</strong>",
          en: "Diagnose issues remotely and <strong>reduce on-site interventions.</strong>",
        },
      },
      fastDeployment: {
        description: {
          fr: "Déployer en quelques heures et <strong>minimisez les travaux</strong>, en milieu occupé.",
          en: "Deploy in hours and <strong>optimize deployement cost</strong>, even in occupied buildings.",
        },
      },
      noInternet: {
        description: {
          fr: "Capable de <strong>fonctionner indépendamment du cloud</strong> et sans Internet.",
          en: "Can <strong>operate without cloud</strong> nor Internet access.",
        },
      },
      hypervision: {
        title: {
          fr: "Gestion multisite centralisée",
          en: "Centralized Multi-Site Management",
        },
        description: {
          fr: "Visualisation énergétique dynamique et intuitive. Déploiement d’automatismes à l’échelle d’un parc immobilier. Alertes de maintenance et sur les seuils d’énergie, de température, de CO₂...",
          en: "Dynamic and intuitive energy visualization. Deploy automation across your entire property portfolio with smart alerts for maintenance, warnings, energy, temperature and CO₂ thresholds.",
        },
      },
      simpleToUse: {
        title: {
          fr: "Simple d'utilisation",
          en: "Simple to Use",
        },
        description: {
          fr: "Conçue pour une prise en main immédiate combinant simplicité et déploiement rapide.",
          en: "Designed for immediate use, combining simplicity with fast deployment.",
        },
      },
      thermalFlexibility: {
        title: {
          fr: "Flexibilité thermique",
          en: "Thermal Flexibility",
        },
        description: {
          fr: "Définissez des règles de température au niveau de votre organisation avec des plages de dérogation manuelle.",
          en: "Define organization-wide temperature rules with flexible manual override ranges.",
        },
      },
      securedAccess: {
        title: {
          fr: "Sécurité des accès à votre organisation",
          en: "Secure Access Management",
        },
        description: {
          fr: "Créez votre organisation, vos multisites, vos sites et administrez tout d’une seule interface. Donnez des accès temporaires aux personnes externes à votre organisation.",
          en: "Create your organization, manage multi-site structures and control everything from a single interface. Grant temporary access to external stakeholders when needed.",
        },
      },
    },
  },
};
